import { getVariantFromId } from "@input-output-hk/essential-cardano-utils";

const variants = ["blue", "red", "black"] as const;
export const getFaqColorFromId = (_id: string) =>
  getVariantFromId(_id, variants);
